type ScopedResultsLike = Array<{
  indexId: string;
  results?: {
    nbHits?: number | null;
  } | null;
}>;

const ALL_TAB_INDEX_IDS = ['watches', 'stores', 'straps', 'eyewear'] as const;

export function getAllTabTotalHits(scopedResults: ScopedResultsLike): number {
  const counted = new Set<string>();

  return scopedResults.reduce<number>((total, result) => {
    if (
      ALL_TAB_INDEX_IDS.includes(
        result.indexId as (typeof ALL_TAB_INDEX_IDS)[number],
      ) &&
      !counted.has(result.indexId)
    ) {
      total += result.results?.nbHits ?? 0;
      counted.add(result.indexId);
    }
    return total;
  }, 0);
}
